import { API } from "@Config/api";

export function sendFraudReport(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/fraud-report`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
